export default __webpack_public_path__ + "static/media/circle-blue.4fb84e62.svg";